import { RiLoader3Fill } from "react-icons/ri";

export const AppLoader = ({ size = 22 }) => {
  return <RiLoader3Fill className="app-loader" size={size} />;
};
